/**
 * Get a ref to a DOM node via a getter function
 * This can be necessary to avoid accessing browser-only variables
 * like 'window' or 'document' directly in a componetn's setup,
 * as this will fail in SSR.
 */
export function useDom(getter, fallbackGetter) {
  return ref(import.meta.env.SSR ? fallbackGetter?.() : getter())
}
